module.exports = __webpack_public_path__ + "static/SLFCspread-2-4be53104d986c94c837b9d5832de8715.jpg";